import {
	SET_ITEMS,
	SET_ITEM,
	CLEAR_ITEMS,
	CLEAR_ITEM,
	ADD_ITEM,
	UPDATE_ITEM,
	REMOVE_ITEM,
} from './actionTypes';

export const item = (state = {}, action) => {
	switch (action.type) {
		case SET_ITEM:
			return action.payload;
		case UPDATE_ITEM:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_ITEM:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_ITEMS:
			return action.payload;
		case ADD_ITEM:
			return [...state, action.payload];
		case UPDATE_ITEM:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_ITEM:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_ITEMS:
			return [];
		default:
			return state;
	}
};
